<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="15" y="103" rx="0" ry="0" width="345" height="98" />
        <rect x="254" y="250" rx="0" ry="0" width="104" height="74" />
        <rect x="13" y="222" rx="0" ry="0" width="345" height="22" />
        <rect x="15" y="252" rx="0" ry="0" width="231" height="46" />
        <rect x="14" y="304" rx="0" ry="0" width="38" height="19" />
        <rect x="15" y="15" rx="0" ry="0" width="345" height="36" />
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <rect x="15" y="65" rx="0" ry="0" width="44" height="28" />
        <rect x="70" y="67" rx="0" ry="0" width="44" height="22" />
        <rect x="122" y="67" rx="0" ry="0" width="44" height="22" />
        <rect x="174" y="67" rx="0" ry="0" width="44" height="22" />
        <rect x="226" y="66" rx="0" ry="0" width="44" height="22" />
        <rect x="279" y="65" rx="0" ry="0" width="44" height="22" />
        <rect x="328" y="64" rx="0" ry="0" width="29" height="22" />
        <rect x="62" y="304" rx="0" ry="0" width="61" height="20" />
        <rect x="255" y="369" rx="0" ry="0" width="104" height="74" />
        <rect x="14" y="341" rx="0" ry="0" width="345" height="22" />
        <rect x="16" y="371" rx="0" ry="0" width="231" height="46" />
        <rect x="15" y="423" rx="0" ry="0" width="38" height="19" />
        <rect x="63" y="423" rx="0" ry="0" width="61" height="20" />
        <rect x="255" y="485" rx="0" ry="0" width="104" height="74" />
        <rect x="14" y="458" rx="0" ry="0" width="345" height="22" />
        <rect x="16" y="487" rx="0" ry="0" width="231" height="46" />
        <rect x="15" y="539" rx="0" ry="0" width="38" height="19" />
        <rect x="63" y="539" rx="0" ry="0" width="61" height="20" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/articleListSkeleton.vue